// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "label{margin:0}label input,label span{cursor:pointer}\n", ""]);
// Exports
module.exports = exports;
